function RequiredFieldLabel() {
  return (
    <small>
      <i>* fields are mandatory</i>
    </small>
  )
};

export default RequiredFieldLabel;
